<template>
  <div>
    <h2>销售</h2>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>